export default __webpack_public_path__ + "static/media/GuideMapSection.199128a9.png";